<template>
  <div id="defaultId1">
    <div class="pb20">
      <div id="cc5f49" class="udb507">
        <div class="right_cont_box company_box margin-bottom10">
          <div class="flex_box">
            <div>
              <i
                class="iconfont icon-fanhui margin-right40"
                @click="$router.go(-1)"
                style="color: #009ea7"
              ></i>
            </div>
            <div>
              <div class="font24 margin-bottom15 font_bold">
                {{ $route.query.companyName }}
              </div>
              <div class="font18 margin-bottom10 flex_center_start">
                <img class="Countryimg" :src="ImgFlag" alt="" /><span>{{
                  $route.query.countryName
                }}</span>
              </div>
              <div class="font18 margin-bottom15">
                <span class="font666666"> C/O: </span>
                <span class="margin-left10"> {{ $route.query.address }}</span>

                <span class="fontDDDDDD margin-left20">|</span>

                <span
                  class="margin-left20 CountryActive"
                  @click="goToWeb($route.query.website)"
                  >{{ $route.query.website }}</span
                >
              </div>

              <div class="font18">
                <span class="font666666">Transaction Year:</span>
                <span> {{ $route.query.lastTradeDate }}</span>

                <span class="fontDDDDDD margin-left20">|</span>
                <span
                  class="font666666 margin-left20"
                  v-if="$route.query.type == 1"
                >
                  Total Import Amount:</span
                >
                <span class="font666666 margin-left20" v-else>
                  Total Export Amount:</span
                >
                <span> {{ $route.query.sumAmount | FilterNum }}</span>
                <span class="fontDDDDDD margin-left20">|</span>
                <span
                  class="margin-left20 font666666"
                  v-if="$route.query.type == 1"
                  >Number of Import:
                </span>
                <span class="margin-left20 font666666" v-else
                  >Number of Exports:
                </span>
                <span>{{ $route.query.sumTransactions }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right_cont_box company_box">
          <div class="table-index">
            <h2 class="operations-head-content">
              <span class="operations-headspan"> Shipping Overview </span>
            </h2>
            <div class="flex_between_box margin-bottom20">
              <div class="table flex_center_star">
                <div class="left_menu_context">
                  <div class="dadePickerBorder flex_between_box">
                    <el-date-picker
                      style="width: 45%"
                      v-model="datePickerOne"
                      prefix-icon="''"
                      class="datePickerOne"
                      value-format="yyyy"
                      type="year"
                      @change="datepcikerChange"
                      placeholder="Start date"
                    >
                    </el-date-picker>
                    <el-date-picker
                      class="datePickerOne"
                      style="width: 50%"
                      v-model="datePickerTwo"
                      type="year"
                      @change="datepcikerChange"
                      value-format="yyyy"
                      placeholder="End date"
                    >
                    </el-date-picker>
                  </div>
                  <!-- <el-date-picker v-model="datePicker" style="width: 100%;" type="monthrange" range-separator=""
                start-placeholder="Start date" value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']" end-placeholder="End date"></el-date-picker> -->
                </div>

                <div class="left_menu_context" v-if="$route.query.type == 2">
                  <el-select
                    :popper-append-to-body="false"
                    filterable
                    v-model="buyerNamevalue"
                    clearable
                    class="margin-left20 top_search_select search-select-con"
                    @change="selectChange"
                    placeholder="Enter Buyer Names"
                  >
                    <el-option
                      v-for="item in buyerNameList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="left_menu_context" v-if="$route.query.type == 1">
                  <el-select
                    :popper-append-to-body="false"
                    filterable
                    v-model="supplierNamevalue"
                    clearable
                    class="margin-left20 top_search_select search-select-con"
                    @change="selectChange"
                    placeholder="Enter Supplier Names"
                  >
                    <el-option
                      v-for="item in supplierNameList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="left_menu_context" v-if="$route.query.type == 1">
                  <el-select
                    :popper-append-to-body="false"
                    filterable
                    v-model="countryOfDesvalue"
                    clearable
                    class="margin-left20 top_search_select"
                    @change="selectChange"
                    :placeholder="$t('Home.selectCountry')"
                  >
                    <el-option
                      v-for="item in countryOfDesList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="left_menu_context" v-if="$route.query.type == 2">
                  <el-select
                    filterable
                    v-model="countryOfOrgvalue"
                    clearable
                    :popper-append-to-body="false"
                    class="margin-left20 top_search_select"
                    @change="selectChange"
                    :placeholder="$t('Home.selectCountry')"
                  >
                    <el-option
                      v-for="item in countryOfOrgList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!-- <div class="left_menu_context">

                                    <el-select :popper-append-to-body="false" v-if="$route.query.type == 1" filterable
                                        v-model="countryOfDesvalue" clearable style="width: 100%;margin-left: 20px;"
                                        @change="selectChange" :placeholder="$t('Home.selectCountry')">
                                        <el-option v-for="item in countryOfDesList" :key="item.value" :label="item.name"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div> -->

                <!-- <div class="left_menu_context">

                                    <el-select filterable v-model="countryOfOrgvalue" v-if="$route.query.type == 2"
                                        clearable :popper-append-to-body="false" style="width: 100%;margin-left: 20px;"
                                        @change="selectChange" :placeholder="$t('Home.selectCountry')">
                                        <el-option v-for="item in countryOfOrgList" :key="item.value" :label="item.name"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div> -->
              </div>
              <el-button
                style="background-color: #009ea7 !important"
                class="btn_export btn_reset"
                @click="ResetTarde()"
              >
                Reset</el-button
              >
            </div>
            <div class="operations-box-bottom table_X">
              <el-table
                :data="ImporttableData"
                style="width: 100%"
                v-loading="loading"
                :key="key"
                empty-text="No Data"
              >
                <el-table-column
                  prop="ie_date"
                  width="200"
                  :label="$t('MyDatabase.Date')"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span class="table-content">{{ scope.row.ie_date }}</span>
                  </template>
                </el-table-column>

                <!-- <el-table-column prop="import_name" label="Buyer Name"
                                    class-name="company company_link company_link_tooltip_normal">
                                    <template slot-scope="scope">
                                        <el-popover placement="top" trigger="click">
                                            <div>
                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p class="products-Shipping-item margin-right40 flex_center_bettwen"
                                                        style="border-top: 1px solid #ccc;">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">ID</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.legalStatus?.id }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen"
                                                        style="border-top: 1px solid #ccc;">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Revenue</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.financialStatus?.revenue }}</span>
                                                    </p>
                                                </div>

                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">{{
                                                            $t('Profile.CompanyType') }}</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.legalStatus?.companyType }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Profit</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.financialStatus?.profit}}</span>
                                                    </p>
                                                </div>
                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Last
                                                            Financial Year</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.financialStatus?.lastYear }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Asset</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.financialStatus?.asset }}</span>
                                                    </p>
                                                </div>
                                                <div class="flex_center_between_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Sharehold</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.legalStatus?.shareholds }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Registration
                                                            Date</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.legalStatus?.registerDate }}</span>
                                                    </p>
                                                </div>
                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Registration
                                                            Status</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.legalStatus?.status }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Credit
                                                            Rating</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.creditRatings?.creditRating }}</span>
                                                    </p>
                                                </div>
                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Industry
                                                            Code</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.current?.industryCode
                                                            }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Credit
                                                            Score</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.creditRatings?.creditScore }}</span>
                                                    </p>
                                                </div>
                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Listed</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.current?.listed }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">ESG
                                                            Rating</span>
                                                        <span class="products-Shipping-table-text">{{
                                                            companyBase?.creditRatings?.ratingESG }}</span>
                                                    </p>
                                                </div>
                                                <div class="flex_center_start_box products-Shipping-box">
                                                    <p
                                                        class="products-Shipping-item margin-right40 flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">Employee</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.current?.employee }}</span>
                                                    </p>

                                                    <p class="products-Shipping-item flex_center_bettwen">
                                                        <span
                                                            class="products-Shipping-table products-Shipping-table-text">DQI</span>
                                                        <span
                                                            class="products-Shipping-table-text">{{ companyBase?.creditRatings?.dQI }}</span>
                                                    </p>
                                                </div>

                                            </div>
                                            <div slot="reference">

                                                <div class=" company_link"
                                                    @click="getCompanySnapDetail(scope.row.import_aaaid)">{{
                                                    scope.row.import_name
                                                    }}<svg t="1740639217247" class="icon SactionIcon"
                                                        v-if="scope.row.import_saction" viewBox="0 0 1293 1024"
                                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6133"
                                                        width="1.4285rem" height="1.4285rem">
                                                        <path
                                                            d="M743.316211 54.649263l487.154526 797.157053A113.178947 113.178947 0 0 1 1133.891368 1024H159.528421A113.178947 113.178947 0 0 1 63.056842 851.806316l487.208421-797.103158A113.178947 113.178947 0 0 1 737.28 45.810526l6.036211 8.838737z m395.15621 853.369263l-487.154526-797.103158-0.754527-1.077894-1.024-0.754527a5.389474 5.389474 0 0 0-7.383579 1.778527l-487.154526 797.103158a5.389474 5.389474 0 0 0 4.581053 8.245894H1133.945263a5.389474 5.389474 0 0 0 4.581053-8.192z"
                                                            fill="#FF6A6A" p-id="6134"></path>
                                                        <path
                                                            d="M646.736842 323.368421a75.290947 75.290947 0 0 1 75.075369 80.626526l-17.354106 242.903579a57.882947 57.882947 0 0 1-115.442526 0l-17.354105-242.903579A75.290947 75.290947 0 0 1 646.736842 323.368421z"
                                                            fill="#FF6A6A" p-id="6135"></path>
                                                        <path
                                                            d="M646.736842 808.421053m-53.894737 0a53.894737 53.894737 0 1 0 107.789474 0 53.894737 53.894737 0 1 0-107.789474 0Z"
                                                            fill="#FF6A6A" p-id="6136"></path>
                                                    </svg></div>
                                            </div>
                                        </el-popover>


                                    </template>
                                </el-table-column>
                                <el-table-column prop="import_country_inter" label="Destination" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span class="table-content ">{{ scope.row.import_country_inter }}</span>
                                    </template>
                                </el-table-column> -->
                <el-table-column
                  prop="export_name"
                  :label="
                    $route.query.type == 1 ? 'Supplier Name' : 'Buyer Name'
                  "
                  class-name="company company_link company_link_tooltip_normal"
                >
                  <template slot-scope="scope">
                    <div>
                      <!-- @click="setid(scope.row, 'Supplier')" -->
                      <span class="table-content CountryActive">
                        <span
                          @click="
                            gotoCompany(scope.row.export_aaaid, export_name)
                          "
                          v-if="$route.query.type == 1"
                        >
                          {{ scope.row.export_name }}
                        </span>

                        <span
                          v-else
                          @click="
                            gotoCompany(scope.row.import_aaaid, import_name)
                          "
                        >
                          {{ scope.row.import_name }}
                        </span>
                        <svg
                          t="1740639217247"
                          class="icon SactionIcon"
                          v-if="scope.row.export_saction"
                          viewBox="0 0 1293 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="6133"
                          width="1.4285rem"
                          height="1.4285rem"
                        >
                          <path
                            d="M743.316211 54.649263l487.154526 797.157053A113.178947 113.178947 0 0 1 1133.891368 1024H159.528421A113.178947 113.178947 0 0 1 63.056842 851.806316l487.208421-797.103158A113.178947 113.178947 0 0 1 737.28 45.810526l6.036211 8.838737z m395.15621 853.369263l-487.154526-797.103158-0.754527-1.077894-1.024-0.754527a5.389474 5.389474 0 0 0-7.383579 1.778527l-487.154526 797.103158a5.389474 5.389474 0 0 0 4.581053 8.245894H1133.945263a5.389474 5.389474 0 0 0 4.581053-8.192z"
                            fill="#FF6A6A"
                            p-id="6134"
                          ></path>
                          <path
                            d="M646.736842 323.368421a75.290947 75.290947 0 0 1 75.075369 80.626526l-17.354106 242.903579a57.882947 57.882947 0 0 1-115.442526 0l-17.354105-242.903579A75.290947 75.290947 0 0 1 646.736842 323.368421z"
                            fill="#FF6A6A"
                            p-id="6135"
                          ></path>
                          <path
                            d="M646.736842 808.421053m-53.894737 0a53.894737 53.894737 0 1 0 107.789474 0 53.894737 53.894737 0 1 0-107.789474 0Z"
                            fill="#FF6A6A"
                            p-id="6136"
                          ></path></svg
                      ></span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="import_country_inter"
                  width="200"
                  :label="$route.query.type == 1 ? 'Destination' : 'Origin'"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span
                      @click="goCountry(scope.row.import_country_code)"
                      class="table-content CountryActive"
                      v-if="$route.query.type == 1"
                      >{{ scope.row.import_country_inter }}</span
                    >
                    <span
                      @click="goCountry(scope.row.export_country_code)"
                      class="table-content CountryActive"
                      v-else
                      >{{ scope.row.export_country_inter }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Amount"
                  wi
                  label="Amount"
                  width="200"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span class="table-content">{{
                      scope.row.total_count | FilterNum
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="Details"
                  label="Details"
                  align="center"
                  width="200"
                >
                  <template slot-scope="scope">
                    <el-popover
                      placement="top"
                      trigger="hover"
                      popper-class="table_popover"
                      content="Waybill Details"
                    >
                      <i
                        slot="reference"
                        @click="gotoExportDetail(scope.row.data_id)"
                        style="color: #009ea7"
                        class="iconfont icon-xiangqing-"
                      ></i>
                    </el-popover>
                    <!-- <span class="table-content">{{ scope.row.Details }}</span> -->
                  </template>
                </el-table-column>
              </el-table>
              <div class="page_i_box">
                <Page
                  :totalFont="true"
                  :total="page.total"
                  :pageSize.sync="page.pageSize"
                  :currentPage="page.pageNo"
                  @onPageChange="onPageChangeListTree"
                ></Page>

                <div class="search_rsult_txt line_2">
                  {{ page.pageNo }}-{{ page.pageSize }} of over
                  {{ page.total | FilterNum }} results for "Shipping Overview"
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>

    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>

  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import Page from "@/components/page/index.vue";
import rectcard from "@/components/rectCard/index.vue";
import content_text from "@/components/text_content/index.vue";
import gui_card from "@/components/gui_card/gui_card.vue";
import { mixins1 } from "@/mixins/index";
import ReLogin from "@/components/ReLogin.vue";
import { getCompanySnap } from "@/api/companyApi.js";
import { searchTradeHscode, searchFilterConditions } from "@/api/searchApi.js";
//importEnd

export default {
  name: "",
  mixins: [mixins1],
  props: {},

  components: {
    gui_card,
    rectcard,
    content_text,
    Page,
    ReLogin,
  },
  computed: {},
  created() {},
  mounted() {
    let countryImg = this.getCountryImgUrl(this.$route.query.countryCode);
    this.ImgFlag = require("../../../../static" + countryImg);
    this.$emit("UpdatamarkTotalList", false);
    this.getsearchFilterConditions();
    this.getCompanyList();
    this.$store.dispatch("app/toggleMenu", true);
    this.$store.dispatch("app/setTools", {
      name: "saved",
      key: "isActive",
      value: true,
    });
  },
  data() {
    return {
      reLoginVis: false,
      key: 0,
      Related: false,
      isExpanded: false,
      datePickerTwo: "",
      parentTablelist: [],
      imexportsDialog: false,
      companyList: [],
      value: {},
      maxCharacters: 200,
      content: [],
      exportLoding: false,
      loading: true,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      ImporttableData: [],
      countryOfDesvalue: "",
      countryOfDesList: [],
      countryOfOrgList: [],
      countryOfOrgvalue: "",

      hsCodeList: [],
      hsCodevalue: "",
      productList: [],

      productvalue: "",
      supplierNameList: [],
      supplierNamevalue: "",
      datePicker: [],
      datePickerOne: "",
      buyerNameList: [],
      buyerNamevalue: "",
      Improtradio: 0,
      companyBase: {},
      ImgFlag: null,

      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  computed: {},
  methods: {
    goToWeb(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
    gotoCompany(item, value) {
      let SACode1 = "";
      let routeData = this.$router.resolve({
        // Tradecompany/Trade/
        // /company/details
        path:
          "/index/tradeCompany/Trade/" +
          item +
          // "/background/snapshot?id3a=" +
          "/tradeMap/map?id3a=" +
          item +
          "&companyCountry=" +
          "" +
          "&SACode1=" +
          SACode1 +
          "&companyName=" +
          value +
          "&Tradechannel=Company" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },
    goCountry(item) {
      let routeData = this.$router.resolve({
        path:
          "/index/TradeCountry/TradeDetail/" +
          item +
          "/tradeMap/map?id3a=" +
          item +
          "&Tradechannel=HsCode" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },
    ResetTarde() {
      this.datePickerOne = "";
      this.datePickerTwo = "";
      this.buyerNamevalue = "";
      this.supplierNamevalue = "";
      (this.countryOfDesvalue = ""), (this.countryOfOrgvalue = "");
      this.selectChange();
    },
    datepcikerChange() {
      if (this.datePickerOne && this.datePickerTwo) {
        let max = Math.min(
          Number(this.datePickerOne == "" ? 0 : this.datePickerOne),
          Number(this.datePickerTwo == "" ? 0 : this.datePickerTwo),
        );
        let min = Math.max(
          Number(this.datePickerOne == "" ? 0 : this.datePickerOne),
          Number(this.datePickerTwo == "" ? 0 : this.datePickerTwo),
        );
        this.datePickerOne = max == 0 ? "" : max.toString();
        this.datePickerTwo = min == 0 ? "" : min.toString();
      }
      this.getCompanyList();
      this.getsearchFilterConditions();
    },

    selectChange() {
      this.getCompanyList();
      this.getsearchFilterConditions();
    },
    getsearchFilterConditions() {
      searchFilterConditions({
        hscode: this.$route.query.id3a,
        keyword: this.$route.query.aaaId,
        import_name: this.buyerNamevalue,
        export_name: this.supplierNamevalue,
        import_country_code: this.countryOfDesvalue,
        export_country_code: this.countryOfOrgvalue,
        startTime: this.datePickerOne,
        endTime: this.datePickerTwo,
      }).then((res) => {
        if (res.code == 200) {
          this.buyerNameList = res.data.buyerNameList;
          this.countryOfDesList = res.data.countryOfDesList;
          this.countryOfOrgList = res.data.countryOfOrgList;
          this.hsCodeList = res.data.hsCodeList;
          this.productList = res.data.hsCodeList;
          this.supplierNameList = res.data.supplierNameList;
        }
      });
    },
    getCompanySnapDetail(value) {
      if (this.$route.query.type == 1) {
        value = value.export_aaaid;
      } else {
        value = value.import_aaaid;
      }
      getCompanySnap({
        id3a: value,
      }).then((res) => {
        this.companyBase = res.data;
      });
    },

    gotoExportDetail(Details) {
      this.$router.push({
        path: "importDetailProduct",
        query: {
          Moudles: this.$route.query.Moudles,
          idpower: this.$route.query.idpower,
          id3a: this.$route.query.id3a,
          SACode1: this.$route.query.SACode1,
          DetailsiD: Details,
        },
      });
    },
    onPageChangeListTree({ page, size }) {
      this.page.pageNo = page;
      this.page.size = size;
      this.getCompanyList();
    },
    getCompanyList() {
      this.loading = true;
      searchTradeHscode({
        hscode: this.$route.query.id3a,
        keyword: this.$route.query.aaaId,
        import_name: this.buyerNamevalue,
        export_name: this.supplierNamevalue,
        // import_name: this.$route.query.type==2?this.$route.query.companyName:'',
        // export_name: this.$route.query.type==1?this.$route.query.companyName:'',
        import_country_code: this.countryOfDesvalue,
        export_country_code: this.countryOfOrgvalue,
        startTime: this.datePickerOne,
        endTime: this.datePickerTwo,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.ImporttableData = res.data.rows;
          this.page.total = res.data.total;
        } else {
          this.ImporttableData = [];
          this.page.total = 0;
        }
      });
    },

    scrollToTop() {
      if (this.parentTablelist.length > 0) {
        // this.Related = true;
      } else {
      }

      this.Related = true;
    },

    // 获取数据

    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 0.2857142857142857rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
}

.importDetail-head {
  display: flex;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #238acc;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.uc1096 {
  height: 100%;
}

.head-titel {
  font-family: "Arial Bold";
  display: flex;
  align-items: center;
}

.operations-head {
  font-family: "Arial Bold";
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer {
  padding-left: 0rem;
  overflow: hidden;
}

.computer_right_cont_box {
  margin-top: 1.4285714285714286rem;
}

.tablewieth {
  width: 70%;
}

.table_box {
  position: relative;
}

.echarts-content {
  margin-top: 2.857142857142857rem;
  padding: 0 4.285714285714286rem;
}

.echarts-item {
  display: flex;
  justify-content: flex-start;
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  line-height: 1.6428571428571428rem;
  margin-bottom: 2.142857142857143rem;
}

.echarts-item-left {
  display: inline-block;
  width: 15.714285714285714rem;
  margin-right: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.ecahrtstutwo {
  position: relative;
  left: 1.4285714285714286rem;
}

.uUIRzUi {
  padding: 2.142857142857143rem 2.857142857142857rem;
}

.left_box {
  width: 91%;
}

.right_box {
  width: 40%;
  background-color: #fff;
}

.operations-box-bottom /deep/ .el-table .cell {
  color: #1a2332;
  line-height: 30px;
}

.companyimg {
  float: left;
  width: 36px;
  height: 26px;
  flex: none;
  margin-right: 4px;
  box-shadow: 0px 1px 2px 0px rgb(0 0 0 / 20%);
}

.left_menu {
  background-color: #fff;
  max-height: 95%;
  overflow-y: auto;
  height: auto;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.udb507 {
  width: 100%;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-direction: column;
  padding-left: 0em;
}

.udb507two {
  width: 100% !important;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 10px;
}

.SactionIcon {
  position: relative;
  top: 0.3rem;
  left: 1rem;
}

.datePickerOne /deep/.el-input__inner {
  border: none !important;
}

.datePickerOne /deep/ .el-input__prefix {
  left: -22px !important;
  color: #1a2332 !important;
}

.dadePickerBorder {
  border-radius: 10px;
  border: 1px solid #cccccc;
}

.dadePickerBorder,
.left_menu_context .top_search_select {
  width: 400px;
  height: 50px;
}

.left_menu_context >>> .el-input__inner,
.dadePickerBorder >>> .el-input__inner {
  font-size: 20px;
  line-height: 48px;
}

.dadePickerBorder >>> .el-input__inner {
  text-align: center;
  padding: 0;
}

.products-Shipping-table {
  width: 13.5714rem;
  background: #f2f5f9;
  font-family: "Arial Bold";
  height: 3.57142857rem;
  line-height: 3.57142857rem;
  display: inline-block;
}

.products-Shipping-table-text {
  padding-left: 1.4285714rem;
  width: 13.5714rem;
}

.products-Shipping-item {
  font-size: 18px;
  color: #1a2332;
  width: 48%;
  border-bottom: 1px solid #cccccc;
}

.Countryimg {
  width: 2.5714285714285716rem;
  height: 1.8571428571428572rem;
  margin-right: 0.7142857142857143rem;
}

.icon-fanhui {
  font-size: 24px;
}

.left_menu_context .top_search_select /deep/ .el-select-dropdown {
  max-width: 800px;
}

@media screen and (max-width: 1920px) {
  .icon-fanhui {
    font-size: 20px;
  }

  .dadePickerBorder {
    border-radius: 7px;
  }

  .dadePickerBorder,
  .left_menu_context .top_search_select {
    width: 300px;
    height: 30px;
  }

  .left_menu_context >>> .el-input__inner,
  .dadePickerBorder >>> .el-input__inner {
    font-size: 14px;
    line-height: 28px;
  }
  .btn_reset {
    font-size: 14px;
  }
  .operations-box-bottom /deep/ .el-table .cell {
    line-height: 28px;
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
}

@media screen and (max-width: 1439px) {
  .right_box {
    padding: 20px 26px 13px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }

  .icon-fanhui {
    font-size: 18px;
  }

  .dadePickerBorder {
    border-radius: 6px;
  }

  .dadePickerBorder,
  .left_menu_context .top_search_select {
    width: 268px;
    height: 26px;
  }

  .left_menu_context >>> .el-input__inner,
  .dadePickerBorder >>> .el-input__inner {
    font-size: 12px;
    line-height: 24px;
  }
  .btn_reset {
    font-size: 12px;
  }
  .operations-box-bottom /deep/ .el-table .cell {
    line-height: 20px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }
}
</style>
